import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CrowdCountObserved } from '../../model/crowd-count-observed';

export interface CrowdCountObservedState extends EntityState<CrowdCountObserved> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CrowdCountObserved' })
export class CrowdCountObservedStore extends EntityStore<CrowdCountObservedState> {

  constructor() {
    super();
  }

}
